(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bsd-category-filters"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var nav = document.querySelector('.bsd-cl-nav');
    if (!nav) return;

    /* Move nav bar after the hero heading but before the category cards */
    var hero = document.querySelector('.bsd-cl .bsd-cl-hero__title');
    if (hero) {
      var heroContainer = hero.closest('.container');
      heroContainer.parentNode.insertBefore(nav, heroContainer.nextSibling);
    } else {
      var landing = document.querySelector('.bsd-cl');
      if (landing) {
        landing.parentNode.insertBefore(nav, landing);
      }
    }

    /* Smooth scroll on click */
    nav.querySelectorAll('.bsd-cl-nav__item[data-scroll-to]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var target = document.getElementById(btn.getAttribute('data-scroll-to'));
        if (target) {
          var offset = window.innerHeight * 0.3;
          var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });

    /* Wrap both filter containers in a single shadow div */
    var topContainer = document.querySelector('.bsd-cl-filters-container--top');
    var bottomContainer = document.querySelector('.bsd-cl-filters-container--bottom');
    if (topContainer && bottomContainer) {
      var shadowWrap = document.createElement('div');
      shadowWrap.className = 'bsd-cl-shadow-wrap';
      topContainer.parentNode.insertBefore(shadowWrap, topContainer);
      shadowWrap.appendChild(topContainer);
      shadowWrap.appendChild(bottomContainer);

      /* Move the nav bar's pill directly above the shadow wrap, flush */
      var navBar = document.querySelector('.bsd-cl-nav__bar');
      var navWrap = document.querySelector('.bsd-cl-nav');
      if (navBar && navWrap) {
        /* Create a centering wrapper for the nav bar directly above shadow wrap */
        var navDock = document.createElement('div');
        navDock.className = 'bsd-cl-nav-dock';
        shadowWrap.parentNode.insertBefore(navDock, shadowWrap);
        navDock.appendChild(navBar);

        /* Add inverted corner connectors using SVG */
        var connSize = 16;
        var connSvg = '<svg width="'+connSize+'" height="'+connSize+'" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">';

        var connLeft = document.createElement('div');
        connLeft.className = 'bsd-cl-connector bsd-cl-connector--left';
        connLeft.innerHTML = connSvg + '<path d="M16,0 Q16,16 0,16 L16,16 Z" fill="#fff"/><path d="M16,0 Q16,16 0,16" fill="none" stroke="#e0e3e6" stroke-width="2"/></svg>';
        shadowWrap.appendChild(connLeft);

        var connRight = document.createElement('div');
        connRight.className = 'bsd-cl-connector bsd-cl-connector--right';
        connRight.innerHTML = connSvg + '<path d="M0,0 Q0,16 16,16 L0,16 Z" fill="#fff"/><path d="M0,0 Q0,16 16,16" fill="none" stroke="#e0e3e6" stroke-width="2"/></svg>';
        shadowWrap.appendChild(connRight);

        /* White cover bar to hide the card's top border under the nav bar */
        var coverBar = document.createElement('div');
        coverBar.className = 'bsd-cl-cover-bar';
        shadowWrap.appendChild(coverBar);

        function positionConnectors() {
          var navRect = navBar.getBoundingClientRect();
          var wrapRect = shadowWrap.getBoundingClientRect();
          connLeft.style.left = (navRect.left - wrapRect.left - connSize) + 'px';
          connRight.style.right = (wrapRect.right - navRect.right - connSize) + 'px';
          coverBar.style.left = (navRect.left - wrapRect.left) + 'px';
          coverBar.style.width = navRect.width + 'px';
        }
        /* Add subtle floating divider between nav and card */
        var divider = document.createElement('div');
        divider.className = 'bsd-cl-nav-divider';
        shadowWrap.appendChild(divider);

        function positionDivider() {
          var navRect = navBar.getBoundingClientRect();
          var wrapRect = shadowWrap.getBoundingClientRect();
          divider.style.left = (navRect.left - wrapRect.left + navRect.width * 0.15) + 'px';
          divider.style.width = (navRect.width * 0.7) + 'px';
        }

        positionConnectors();
        positionDivider();
        window.addEventListener('resize', function() {
          positionConnectors();
          positionDivider();
        });

        /* Hide the original nav container */
        navWrap.style.display = 'none';
      }
    }

    /* Move the Shop All CTA button below the shadow wrapper */
    var cta = document.querySelector('.bsd-cl-cta-wrap');
    var shadowEl = document.querySelector('.bsd-cl-shadow-wrap');
    if (cta && shadowEl) {
      shadowEl.parentNode.insertBefore(cta, shadowEl.nextSibling);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
